// extracted by mini-css-extract-plugin
export var card = "_m3-0";
export var content = "_m3-2";
export var details = "_m3-3";
export var icon = "_m3-1";
export var iconBlue = "_m3-5";
export var iconBrand = "_m3-4";
export var iconGrayBlue = "_m3-6";
export var iconGreen = "_m3-7";
export var iconIndigo = "_m3-8";
export var iconOrange = "_m3-9";
export var iconPurple = "_m3-a";
export var iconRed = "_m3-b";
export var iconWarning = "_m3-c";